import React from 'react';
import {PlacementTest} from '../../../../graphql/API';

type CertificatesScoreTableProps = {
  placementTest: PlacementTest;
};
export const CertificatesScoreTable = ({
  placementTest,
}: CertificatesScoreTableProps) => {
  console.log('mhhr placementTest->', placementTest);
  return (
    <div className="">
      <table className="table-auto w-full text-left">
        <thead className="certificates-table-1">
          <tr>
            <td className=" py-2 fw-bold" style={{paddingLeft: '0!important'}}>
              CEFR Score
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col ">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Pronunciation
                </span>
                <span className="fw-bolder">
                  {!placementTest?.cefrPronunciationAverage?.length
                    ? '-'
                    : placementTest.cefrPronunciationAverage}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Fluency
                </span>
                <span className="fw-bolder">
                  {!placementTest?.cefrFluencyAverage?.length
                    ? '-'
                    : placementTest.cefrFluencyAverage}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Grammar
                </span>
                <span className="fw-bolder">
                  {!placementTest?.cefrGrammarAverage?.length
                    ? '-'
                    : placementTest.cefrGrammarAverage}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Coherence
                </span>
                <span className="fw-bolder">
                  {!placementTest?.cefrCoherenceAverage?.length
                    ? '-'
                    : placementTest.cefrCoherenceAverage}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Vocab
                </span>
                <span className="fw-bolder">
                  {!placementTest?.cefrVocabAverage?.length
                    ? '-'
                    : placementTest.cefrVocabAverage}
                </span>
              </div>
            </td>
          </tr>
        </thead>
        <tbody className="certificates-table-2">
          <tr>
            <td className=" py-2 fw-bold" style={{marginLeft: '0!important'}}>
              IELTS Score
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col ">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Pronunciation
                </span>
                <span className="fw-bolder">
                  {placementTest?.ieltsPronunciationAverage
                    ? placementTest?.ieltsPronunciationAverage
                    : '-'}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Fluency
                </span>
                <span className="fw-bolder">
                  {placementTest?.ieltsFluencyAverage
                    ? placementTest?.ieltsFluencyAverage
                    : '-'}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Grammar
                </span>
                <span className="fw-bolder">
                  {placementTest?.ieltsGrammarAverage
                    ? placementTest?.ieltsGrammarAverage
                    : '-'}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Coherence
                </span>
                <span className="fw-bolder">
                  {placementTest?.ieltsCoherenceAverage
                    ? placementTest?.ieltsCoherenceAverage
                    : '-'}
                </span>
              </div>
            </td>
            <td className="px-4 py-2">
              <div className="flex flex-col">
                <span className="text-xs text-gray-500 d-block certificates-table-header">
                  Vocab
                </span>
                <span className="fw-bolder">
                  {placementTest?.ieltsVocabAverage
                    ? placementTest?.ieltsVocabAverage
                    : '-'}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
